/** Spend + wealth category catalog for transaction edit (mirrors budget-server Category.ts). */

export type TransactionCategoryOption = {
  name: string;
  slug: string;
};

export const SPEND_CATEGORIES: readonly TransactionCategoryOption[] = [
  { name: 'Groceries', slug: 'groceries' },
  { name: 'Dining', slug: 'dining' },
  { name: 'Housing', slug: 'housing' },
  { name: 'Household', slug: 'household' },
  { name: 'Transport', slug: 'transport' },
  { name: 'Subscriptions', slug: 'subscriptions' },
  { name: 'Entertainment', slug: 'entertainment' },
  { name: 'Health', slug: 'health' },
  { name: 'Insurance', slug: 'insurance' },
  { name: 'Shopping', slug: 'shopping' },
  { name: 'Utilities', slug: 'utilities' },
  { name: 'Childcare', slug: 'childcare' },
  { name: 'Other', slug: 'other' },
] as const;

export const WEALTH_CATEGORIES: readonly TransactionCategoryOption[] = [
  { name: 'Salary', slug: 'salary' },
  { name: 'Investment', slug: 'investment' },
  { name: 'Transfer', slug: 'transfer' },
  { name: 'Payments', slug: 'payments' },
  { name: 'Dividend', slug: 'dividend' },
  { name: 'Interest', slug: 'interest-income' },
  { name: 'Refund', slug: 'refund' },
  { name: 'Other Income', slug: 'other-income' },
] as const;

/** Full picker list for recategorizing a transaction. */
export const TRANSACTION_CATEGORY_OPTIONS: readonly TransactionCategoryOption[] = [
  ...SPEND_CATEGORIES,
  ...WEALTH_CATEGORIES,
];

/** Resolve a slug from API categoryName (or slug) for the edit picker. */
export function slugFromCategoryName(nameOrSlug?: string | null): string {
  if (!nameOrSlug?.trim()) return 'other';
  const key = nameOrSlug.trim().toLowerCase();
  const bySlug = TRANSACTION_CATEGORY_OPTIONS.find((c) => c.slug === key);
  if (bySlug) return bySlug.slug;
  const byName = TRANSACTION_CATEGORY_OPTIONS.find((c) => c.name.toLowerCase() === key);
  if (byName) return byName.slug;
  return 'other';
}

export function nameForCategorySlug(slug: string): string {
  return TRANSACTION_CATEGORY_OPTIONS.find((c) => c.slug === slug)?.name ?? slug;
}
